var React = require('react');

function TickIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m17.31816.10606-.106-.10606-.1061.10606-11.1869 11.1869-4.1869-4.1869-.10607-.10606-.10606.10606-1.41407 1.41407-.10606.10606.10606.10607 5.70703 5.707.10607.1061.10607-.1061 12.70703-12.707.1061-.10607-.1061-.10606z","stroke":"#000","strokeWidth":".3","transform":"translate(1.08084 1.08084)"}));
}

TickIconInline.defaultProps = {"height":"16","viewBox":"0 0 20 16","width":"20"};

module.exports = TickIconInline;

TickIconInline.default = TickIconInline;
